<template>
  <div>
    <h1>About</h1>
    <p>Dies ist die Über-uns-Seite.</p>
    <p>
      <a href="https://www.flaticon.com/free-icons/germany" title="germany icons"
        >Germany icons created by Freepik - Flaticon</a
      >
      <a href="https://www.flaticon.com/free-icons/uk-flag" title="uk flag icons"
        >Uk flag icons created by Freepik - Flaticon</a
      >
    </p>
  </div>
</template>
